import 'slick-carousel'
import GET_INSTAGRAM from '../plugins/getInstagram'
import GET_ARTICLES from '../plugins/getArticles'
import ScrollDir from "../class/scrollDir";

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const slider = {
  obj: '[data-plugin="slider"]',
  animationDuration: 8000,
  init() {
    $(this.obj).slick({
      autoplay: true,
      fade: true,
      dots: false,
      speed: 2000,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false
    })
    $(this.obj).on('beforeChange', (e, slick, cs, ns) => {
      $(`[data-slick-index=${ns}]`).addClass('is-animation-start')
      setTimeout(() => $(`[data-slick-index=${ns}]`).removeClass('is-animation-start'),
        this.animationDuration
      )
    })
  },
  start() {
    $(this.obj).slick('slickPlay').addClass('is-slickPlay')
    $(`[data-slick-index=0]`).addClass('is-animation-start')
    setTimeout(() => $(`[data-slick-index=0]`).removeClass('is-animation-start'),
      this.animationDuration
    )
  }
}

class pickupBanner {
  constructor( selector, classname='is-scrollup' ){
    new ScrollDir();
    this.elm = d.querySelector(selector);
    if (this.elm) {
      this.scrollDir = new ScrollDir();
      this.addclass(classname);
    }
  }

  addclass(classname) {
    d.addEventListener('Scroll.scrollUp', () => this.elm.classList.add(classname) );
    d.addEventListener('Scroll.scrollDown', () => this.elm.classList.remove(classname) );
  }
}

const init = () => {
  w.load['mainvisual'].then( () => {
    slider.init(), slider.start()

    // pickupのフェードアウト
    const pickupClose = d.getElementById('pickupClose');
    pickupClose.addEventListener('click', () => {
      $('.mainvisual-pickup').fadeOut();
    });

    // pickupのスクロール移動
    new pickupBanner('.mainvisual-pickup[data-plugin="pickupBanner"]');
  })
  //ticker
  $.when(w.load['mainvisual']).then( ()=> {
    let makeItem = item => $(`
      <a href="${item.href}" class="link mainvisual-pickup__item">
        <figure class="mainvisual-pickup__img">
          <div class="mainvisual-pickup__img-cover" style="background-image:url(${item.thumb})">
           <img src="${item.thumb}" alt="${item.title}" width="240" loading="lazy">
          </div>
       </figure>
      </a>
    `)[0]
    GET_ARTICLES('.mainvisual-pickup__article[data-plugin="getArticles"]', { makeItem })
  })
  //ticker
  $.when(w.load['block-ticker']).then( ()=> {
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <span class="date">${item.date}</span>
        <span class="cate">【${item.category.name}】</span>
        <span class="subject">${item.title}</span>
      </a>
    `)[0]
    GET_ARTICLES('.block-ticker__article[data-plugin="getArticles"]', { makeItem })
  })

  // pickup
  $.when(w.load['block-pickup']).then( () => {
    let makeItem = item => $(`
      <li class="block-pickup-item">
        <a href="${item.href}">
          <figure class="block-pickup__img">
            <div class="block-pickup__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="240" loading="lazy"></div>
          </figure>
          <div class="block-pickup__body">
            <span class="date">${item.date}</span>
            <span class="subject">${item.title.str_truncate(24)}</span>
          </div>
        </a>
      </li>
      `)[0]
    GET_ARTICLES('.block-pickup__list[data-plugin="getArticles"]', { makeItem }).then(
      items => {
        if ( items.length == 0 ) { $('.block-pickup, .mainvisual-pickup').hide() }
      })
  })

  // uservoice
  $.when(w.load['block-uservoice']).then( () => {
    let makeItem = item => $(`
      <li class="block-uservoice-item">
        <a href="${item.href}">
          ${item.keywords ? `<span class="firstTag">${item.keywords[0]}</span>` : ''}
          <figure class="block-uservoice__img">
            <div class="block-uservoice__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="240" loading="lazy"></div>
          </figure>
          <div class="block-uservoice__body">
            <span class="subject">${item.title.str_truncate(24)}</span>
          </div>
        </a>
      </li>
      `)[0]

    GET_ARTICLES('.block-uservoice__list[data-plugin="getArticles"]', { makeItem }).then(
      items => {
        if ( items.length == 0 ) { $('.block-uservoice').hide() }
      })
  })

  // news
  $.when(w.load['block-news']).then( () => {
    let makeItem = item => $(`
      <li class="block-news-item">
        <a href="${item.href}">
          <div class="block-news__body">
            <span class="date">${item.date}</span>
            <span class="cate">【${item.category.name}】</span>
            <span class="subject ${item.is_new ? 'is-new': ''}">${item.title.str_truncate(24)}</span>
          </div>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem })
  })

  //sns
  $.when(w.load['block-sns']).then( () => {
    let fbroot = d.createElement('div')
    fbroot.id = 'fb-root'
    d.body.appendChild( fbroot )
    w.addScript({
      async: '',
      defer: '',
      crossorigin: "anonymous",
      src: "https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v7.0",
      nonce: "n5Xi5Pjk"
    })
    GET_INSTAGRAM()
  })
}


export default function HOME() {
  $( init )
}